export const enum AppRoutes {
  manageBooking = 'manage-booking',
  selfReaccommodation = 'self-reaccommodation',
  refund = 'refund'
}

export const enum SelfReaccommodationRoutes {
  availability = 'availability',
  confirmation = 'confirmation',
  retrieve = 'retrieve',
  review = 'review'
}

export const enum SharedRoutes {
  challenge = 'challenge',
  recovery = 'recovery'
}

export const enum RefundRoutes {
  review = 'review',
  confirmation = 'confirmation',
  selectPassengers = 'select-passengers'
}

export const selfReaccommodationPageIds: {[key in SelfReaccommodationRoutes]: string} = {
  [SelfReaccommodationRoutes.retrieve]: 'IDENTIFICATION',
  [SelfReaccommodationRoutes.availability]: 'AVAILABILITY',
  [SelfReaccommodationRoutes.review]: 'REVIEW',
  [SelfReaccommodationRoutes.confirmation]: 'CONFIRMATION'
};

export const selfReaccommodationPageNames: {[key in SelfReaccommodationRoutes]: string} = {
  [SelfReaccommodationRoutes.retrieve]: 'Identification page',
  [SelfReaccommodationRoutes.availability]: 'Availability page',
  [SelfReaccommodationRoutes.review]: 'Review page',
  [SelfReaccommodationRoutes.confirmation]: 'Confirmation page'
};

export const sharedPageIds: {[key in SharedRoutes]: string} = {
  [SharedRoutes.challenge]: 'CHALLENGE',
  [SharedRoutes.recovery]: 'RECOVERY'
};

export const sharedPageNames: {[key in SharedRoutes]: string} = {
  [SharedRoutes.challenge]: 'Challenge page',
  [SharedRoutes.recovery]: 'Recovery page'
};

export const refundPageIds: {[key in RefundRoutes]: string} = {
  [RefundRoutes.selectPassengers]: 'SELECT_PASSENGERS',
  [RefundRoutes.review]: 'REVIEW',
  [RefundRoutes.confirmation]: 'CONFIRMATION'
};

export const refundPageNames: {[key in RefundRoutes]: string} = {
  [RefundRoutes.selectPassengers]: 'Refund passenger selection page',
  [RefundRoutes.review]: 'Refund review page',
  [RefundRoutes.confirmation]: 'Refund confirmation page'
};

/**
 * A type for the self reacc routes in the application
 */
export type CombinedSelfReaccRoute = `${AppRoutes}/${SelfReaccommodationRoutes}`;

/**
 * A type for the refund routes in the application
 */
export type CombinedRefundRoute = `${AppRoutes}/${RefundRoutes}`;

/**
 * The routes for which the skeleton loader should be displayed
 */
export const skeletalRoutes: (CombinedSelfReaccRoute | CombinedRefundRoute | AppRoutes)[] = [
  `${AppRoutes.selfReaccommodation}/${SelfReaccommodationRoutes.retrieve}`,
  `${AppRoutes.selfReaccommodation}/${SelfReaccommodationRoutes.availability}`,
  AppRoutes.refund
];

/**
 * The routes for which the skeleton loader should not be displayed
 */
export const ineligibleRoutesForSkeleton: (CombinedSelfReaccRoute | CombinedRefundRoute)[] = [
  `${AppRoutes.refund}/${RefundRoutes.selectPassengers}`,
  `${AppRoutes.refund}/${RefundRoutes.confirmation}`
];
